import { Component, OnInit } from '@angular/core'
import { RelatorioResumidoComponent } from '../relatorio-resumido/relatorio-resumido.component'

@Component({
    selector: 'col-relatorio-detalhado',
    templateUrl: './relatorio-detalhado.component.html',
    styleUrls: ['./relatorio-detalhado.component.scss']
})
export class RelatorioDetalhadoComponent extends RelatorioResumidoComponent {}



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/relatorio-detalhado/relatorio-detalhado.component.ts